export default __webpack_public_path__ + "static/media/ipX8.97689ade.svg";